import { Outlet } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

import { ProcessDocumentTopBar } from './ui/process-document-top-bar/process-document-top-bar'

export const ProcessDocumentLayout = () => {
  return (
    <main className={cn('flex flex-col', 'h-full')}>
      <ProcessDocumentTopBar />

      <div className={cn('flex-1')}>
        <Outlet />
      </div>
    </main>
  )
}
